import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Join from '../../components/JoinModal/JoinModal';
import Modal from '../../components/Modal/Modal';

class Integration extends Component {
  state = {
    modal: false
  }
  render() {
    const styles = require('./Integration.less');

    return [
      <Helmet
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Интеграции Mvoter с другими сервисами для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Интеграция MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Интеграции Mvoter с другими сервисами</h1>
            <ul className={ styles.filter }>
              <li>Все</li>
              <li>Рекламные площадки</li>
              <li>CRM</li>
              <li>CPA-сети</li>
              <li>Интеграции через Альбато</li>
              <li>Системы аналитики</li>
            </ul>
            <ul className={ styles.list }>
              <li>
                <div className={ styles.logo }><img src="./images/integration/1.png" width="160" height="78" alt="logo" /></div>
                <div className={ styles.description }>Настройка интеграции с Google Analytics</div>
              </li>
              <li>
                <div className={ styles.logo }><img src="./images/integration/2.png" width="190" height="70" alt="logo" /></div>
                <div className={ styles.description }>Настройка интеграции с Microsoft Power BI</div>
              </li>
              <li>
                <div className={ styles.logo }><img src="./images/integration/3.png" width="150" height="78" alt="logo" /></div>
                <div className={ styles.description }>Настройка интеграции с 1C</div>
              </li>
            </ul>
            <h3>Нужна помощь в настройке интеграции?</h3>
            <p>Позвоните нам по телефону +7 7172 978271 или закажите обратный звонок с сайта</p>
            <h3>Создайте систему обратной связи сейчас. Это просто.</h3>
            <ul className={ styles.buttons }>
              <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
              <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
            </ul>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default Integration;
